import { InfoBar } from "@components/common/info-bar";
import { getMemberDisplayName } from "@utils/data-display";
import { BaseMemberProps } from "@custom-types/base-types";

/**
 * Display member information in the header of member profile page
 */
export function MemberProfileHeader({
  member,
}: BaseMemberProps): React.JSX.Element {
  return (
    <InfoBar
      items={[
        { label: "Member", content: getMemberDisplayName(member) },
        { label: "Email", content: member.email },
      ]}
    />
  );
}
